/* eslint-disable no-dupe-keys */
export default {
  device_order: {
    name: '设备订单',
    // 属性（一般与对象内容匹配）
    prop: {
      device_start_seq: '设备订单编号',
      start_soc: '开始SOC',
      stop_soc: '停止SOC',
      soc: 'SOC',
      start_time: '开始时间',
      end_time: '结束时间',
      charge_energy: '电量',
      electric_money: '电费',
      service_money: '服务费',
      total_money: '订单总额',
      charger: '充电桩',
      charge_station: '充电站',
      charge_record: '充电记录',
      msg_time: '消息时间',
      stop_reason: '结束原因',
      created_at: '账单结算时间',
      updated_at: '更新时间',
      device_sn: '设备编号',
      charger: '站桩',
      order_trade_number: '平台订单编号'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '设备订单/设备编号/站名',
      search_order_trade_number: '完整的平台订单编号'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    titles: {
      base_info: '基本信息',
      fee_info: '桩计费',
      platform_order_info: '平台订单',
      time_sharing_info: '桩分时价格与电量'
    },
    labels: {
      platform_order_sn: 'ECMP订单编号',
      platform_order_user: '充电用户',
      platform_charging_started_at: '启动时间',
      platform_charging_finished_at: '结束时间',
      platform_stop_reason: '结束原因',
      platform_order_amount: '订单金额',
      platform_order_power: '电量',
      order_trade_number: '订单号'
    },
    btn: {
      device_test_report: '设备测试报告'
    }
  }
}
